import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import promocode from "../../assests/images/promocode.webp";
import noPromo from "../../assests/images/no-promo.webp";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { getPromoCode } from "../../services/apiServices/GetServices";

//component imports
import Loader from "../loadingScreens/Loader";

const PromoCode = () => {

  const [promoCode, setPromoCode] = useState();
  const [copied,setCopied]=useState("copy")
  const [isLoader,setIsLoader]=useState(false)
  const history = useHistory();

 
  useEffect(() => {
    callPromoCodeApi()
}, []);


  const handleBuyshare = () => {
    history.push('/customerPortal/myShares/buyShares')
  }

 const handleOnCopied = () => {
    setCopied("copied")
 }

  const callPromoCodeApi = async (n) => {
    setIsLoader(true)
    try{
      const res = await getPromoCode("voucher")

      if (res?.success) {
          // showToast(1, res?.message)
          if(res?.data[0].voucher !== null )
          { setPromoCode(res?.data[0].voucher)}
          else
          { setPromoCode(null) 
          }
          
      } else {
          console.log("res", res?.message)
      }
    }catch(error){
      console.log("error",error)
    }
   
};

  if (promoCode === undefined || promoCode === null) {
    return (
      <div class="d-flex flex-column justify-content-center align-items-center">
        {isLoader ? <Loader/> : null}
         <h1 class="fs-4 w-100 border-bottom border-top mb-xxl-5 p-2">
         Promo Code
            </h1>
        <div class="card w-50 text-center mt-5 p-0">
          <img src={noPromo} class="card-img-top" alt="OSAN-promocode" />
          <div class="card-body d-flex flex-column justify-content-around foaterBackgroundStyle" >
            <h2 class="card-title fw-bold">No Promo Code!</h2>
            <h5>Unlock exclusive discounts.</h5>
          </div>
        </div>
        <h5 class="my-2">Buy Osan shares now to access exciting promo codes!</h5>
        <div class="align-self-center">
        <button type="submit" class="primaryButton  my-3" onClick={handleBuyshare}>
           Buy Shares
        </button>
        </div>
      </div>
    )
  } else {
   
    return (
      <div class="col-md-12 full-height">
          <div class="d-flex flex-column justify-content-center align-items-center ">
         <h1 class="fs-4 w-100 border-bottom border-top mb-xxl-5 p-2">
         Promo Code
            </h1>
        <h6 class="mt-2">Congratulations on purchasing Osan Grows Shares! Your promo code is generated exclusively for you.</h6>
        <div class="card w-50 text-center my-4 border border-1 border-primary">
          <img src={promocode} class="card-img-top" alt="OSAN-promocode" />
          <div class="card-body d-flex flex-row justify-content-center foaterBackgroundStyle" >
            <h2 class="card-title fw-bold mx-2">{promoCode}</h2>
            <div class="cursorPointer" onClick={() => handleOnCopied()}>
            <CopyToClipboard text={promoCode}>
            <i class="bi bi-copy mx-2"></i>
          </CopyToClipboard>
          <CopyToClipboard text={promoCode}>
          <p>{copied}</p>
          </CopyToClipboard>
          </div>
          </div>
        </div>
        <h6 class="w-75 text-center">Enjoy exclusive discounts and benefits with your unique Osan Grows Shares unique code!</h6>
        <p class="mt-3 w-75"><span class="fw-bold fs-5 text-black"> Steps To Redeem </span><br/><b>Code Applicable & Usage:</b> Valid for discounts only at Osan stores across India on your purchases during checkout.<br/> <b>Coupon Validation:</b> Code will be inactive if all shares are sold and you're not holding any shares.</p>
      </div>
      </div>
      
    )
  }
}

export default PromoCode